module.exports = __webpack_public_path__ + "static/img/iot2.993dd1f9.jpg";